import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAppContext } from "../store";
import { canAccessGuardedRoute, readOnboardingSession } from "../lib/onboardingFirstRun";

export function OnboardingGuard({
  children,
  allowInProgress = false,
}: {
  children: ReactNode;
  allowInProgress?: boolean;
}) {
  const { state } = useAppContext();
  if (
    !canAccessGuardedRoute(
      state.settings.onboardingCompleted,
      allowInProgress,
      readOnboardingSession(),
    )
  ) {
    return <Navigate to="/onboarding" replace />;
  }
  return <>{children}</>;
}
